import { DataSourceMode, Label, Panel, TableRow, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutCurrentDispatchStops } from "./autogen/AutogenLayoutCurrentDispatchStops";
import { ModelRow } from "@mcleod/core";

export class CurrentDispatchStops extends AutogenLayoutCurrentDispatchStops {
    tableStopsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.target as TableRow;
        const modelRow: ModelRow = tableRow.data as ModelRow;

        const labelDeparted: Label = tableRow.findComponentById("labelDeparted") as Label;
        const panelOperationalStatus: Panel = tableRow.findComponentById("panelMovementOperationalStatus") as Panel;
        const locationName: Textbox = tableRow.findComponentById("textboxLocationName") as Textbox;
        const actualDeparture: Textbox = tableRow.findComponentById("textboxStopActualDeparture") as Textbox;
        const stopEta: Textbox = tableRow.findComponentById("textboxStopEta") as Textbox;
        const schedArriveEarly: Textbox = tableRow.findComponentById("textboxSchedArriveEarly") as Textbox;
        const schedArriveLate: Textbox = tableRow.findComponentById("textboxSchedArriveLate") as Textbox;

        if (this.mainDataSource.mode === DataSourceMode.UPDATE || this.mainDataSource.mode === DataSourceMode.NONE) {
            if (tableRow.data?.get("stop.actual_departure") != null) {
                labelDeparted.visible = true;
            }

            if (tableRow.index == 0 && tableRow.data.get("movement.operational_status") != null) {
                panelOperationalStatus.visible = true;
            }

            if (locationName != null) {
                locationName.quickInfoOverrideKeyValue = modelRow.get("stop.location_id");
            }

            if (tableRow.data?.get("stop.actual_arrival") != null) {
                stopEta.visible = false;
            } else {
                actualDeparture.visible = false;
            }

            const stopType: string = tableRow.data?.get("stop.stop_type");
            if (stopType == "PU" || stopType == "SP") {
                schedArriveEarly.caption = "Early Pickup";
                schedArriveLate.caption = "Late Pickup";
            } else if (stopType == "SO" || stopType == "SD") {
                schedArriveEarly.caption = "Early Delivery";
                schedArriveLate.caption = "Late Delivery";
            }
        }
    }
}
